<template>
  <div id="search-screen" class="screen">
    <h1>SZUKASZ CZEGOŚ?</h1>
    <p>Wpisz nazwę produktu!</p>

    <label id="search-bar">
      <input type="text" name="search-bar" v-model="searchData">
    </label>
  </div>
</template>

<script>
export default {
  name: 'SearchScreen',
  data() {
    return {
      searchData: null,
    };
  },
  watch: {
    searchData() {
      if (this.searchData !== null && this.searchData !== '') {
        this.$emit('search', { is: true, value: this.searchData });
      } else {
        this.$emit('search', { is: false, value: null });
      }
    },
  },
};
</script>

<style scoped lang="scss">
  #search-screen {
    position: relative;
    height: 50vh; width: 100%;
    background-color: rgba(255,255,255, 0.7);

    background-image: url("../../assets/backgrounds/bg-search.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    background-blend-mode: color;
    padding: 5px 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
      font-family: "Josefin Sans", sans-serif;
      font-weight: bold;
      font-size: 1.8em;
    }

    p {
      padding: 5px;
      left: 0;
    }

    input {
      width: 250px; height: 35px;
      border: 1px solid black;
      border-radius: 5px;

      font-family: Quicksand, sans-serif;
      font-weight: normal;
      text-align: center;
      font-size: 1em;

      margin: 10px 0;

      @media (min-width: 992px) {
        width: 450px;
        height: 40px;
        font-size: 1.4em;
      }
    }

    label {
      &::before {
        position: relative;
        color: #424242;
        font-family: fontello, sans-serif;
        display: block; content: '\e805';
        font-size: 1.24em;
        top: 36px; right: -100px;

        @media (min-width: 992px) { top: 39px; right: -200px; }
      }
    }
  }
</style>
